import { MdEdit } from "react-icons/md";
import { FaEye, FaSync, FaTrash } from "react-icons/fa";
import useModal from "../../hooks/useModal";
import { Container, IconContainer, IconContainerTrash } from "./style";
import { useValidatePermission } from "core/features/auth/hooks/useValidatePermission";

interface ActionsProps {
  id: string;
}

function Actions({ id }: ActionsProps) {
  const {
    setIsDeleting,
    setIsEditing,
    setIsOpen,
    setIsViewingJobs,
    setId,
    setIsSyncingJobs,
  } = useModal();

  const { hasPermission } = useValidatePermission();

  const isEditModalVisible = hasPermission(["RecurringJobGroup.Alterar"]);
  const isDeleteModalVisible = hasPermission(["RecurringJobGroup.Excluir"]);
  const isSyncModalVisible = hasPermission(["RecurringJobGroup.Executar"]);
  const isViewJobsVisible = hasPermission(["RecurringJobGroup.Listar"]);

  const handleOpenDeleteModal = () => {
    if (isDeleteModalVisible) {
      setId(id);
      setIsDeleting(true);
    }
  };

  const handleOpenEditModal = () => {
    if (isEditModalVisible) {
      setIsEditing(true);
      setId(id);
      setIsOpen(true);
    }
  };

  const handleViewJobs = () => {
    setId(id);
    setIsViewingJobs(true);
  };

  const handleSyncJobs = () => {
    setId(id);
    setIsSyncingJobs(true);
  };

  return (
    <Container>
      <IconContainer isActive={isEditModalVisible}>
        <MdEdit size={18} color="#757575" onClick={handleOpenEditModal} />
      </IconContainer>

      <IconContainer isActive={isViewJobsVisible}>
        <FaEye size={18} color="#757575" onClick={handleViewJobs} />
      </IconContainer>

      <IconContainerTrash isActive={isDeleteModalVisible}>
        <FaTrash size={18} color={"#757575"} onClick={handleOpenDeleteModal} />
      </IconContainerTrash>

      <IconContainer isActive={isSyncModalVisible}>
        <FaSync size={18} color="#757575" onClick={handleSyncJobs} />
      </IconContainer>
    </Container>
  );
}

export default Actions;
